<template>
  <product-infowrap :product="product" :fields="fields" :title="titleText" :baseDomain="baseDomain" :shopId="shopId"></product-infowrap>
</template>

<script>
import ProductInfowrap from '~/components/ProductInfowrap.vue'

export default {
  data () {
    return {
      fields: [
        'duration',
        'categories',
        'originaltitle',
        'director',
        'actors',
        'script',
        'creditsmisc',
        'materialnotes',
        'furtherinformation',
        'website'
      ]
    }
  },
  props: ['product', 'baseDomain', 'shopId'],
  components: {
    ProductInfowrap
  },
  computed: {
    titleText () {
      return (this.product.displayedtype === 'movie' ? this._('Movie details') : this._('Details'))
    }
  }
}
</script>
